export const CLIENTS = [
  { name: "Bakked Diamond", logo: "/bakked-diamond-logo.webp" },
  { name: "Bread-G", logo: "/breadg-logo.webp" },
  { name: "HAFIZ A SATTAR SONS SEWAI", logo: "/hafiz-logo.webp" },
  { name: "Jail Police", logo: "/jail-police-logo.webp" },
  { name: "Ashok", logo: "/ashok-logo.webp" },
  { name: "Goldiee Masale", logo: "/goldiee-logo.webp" },
  { name: "Bran-O", logo: "/brano-logo.webp" },
  { name: "Popular", logo: "/popular-logo.webp" },
  { name: "Gomti Food Products", logo: "/gomti-logo.webp" },
  { name: "Milkmade", logo: "/milkmade-logo.webp" },
  { name: "Swati Food Products", logo: "/swati-logo.webp" },
  { name: "Baked Well", logo: "/baked-well-logo.webp" },
  { name: "Nova", logo: "/nova-logo.webp" },
  { name: "Mother", logo: "/mother-logo.webp" },
  { name: "OnceMore Rainforest", logo: "/rainforest-logo.webp" },
  { name: "Maheshwari Sweets", logo: "/maheshwari-logo.webp" },
  { name: "thekaranfoods", logo: "/karans-logo.webp" },
  { name: "Paradise", logo: "/paradise-logo.webp" },
  { name: "Veetaday Industries", logo: "/veetaday-logo.webp" },
  { name: "Good Morning Nutritive India", logo: "/goodmorning-logo.webp" },
  { name: "Kalory", logo: "/kalory-logo.webp" },
  { name: "Amrit Taaza", logo: "/amrit-taaza-logo.webp" },
  { name: "Anand Bakery", logo: "/anand-bakery-logo.webp" },
  { name: "Mithila Naturals", logo: "/mithila-logo.webp" },
  { name: "Sangri-La Nutri Food Products", logo: "/sangrila-logo.webp" },
  { name: "SDZ FOOD PRODUCTS", logo: "/sdz-logo.webp" },
  { name: "GS Manglani", logo: "/gs-manglani-logo.webp" },
  { name: "Meera Bakers", logo: "/meera-bakers-logo.webp" },
  { name: "Badshah", logo: "/badshah-logo.webp" },
  { name: "Banas Dairy", logo: "/banas-dairy-logo.webp" },
  { name: "Amul", logo: "/amul-logo.webp" },
  { name: "Britannia", logo: "/britannia-logo.webp" },
  { name: "Parle", logo: "/parle-logo.webp" },
  { name: "Gogiya", logo: "/gogiya-logo.webp" },
];
